module.exports = __webpack_public_path__ + "img/sepa.0091dc1f.svg";